var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIlGraycoin80Px = function SvgIlGraycoin80Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 73.333c18.41 0 33.333-14.924 33.333-33.333C73.333 21.59 58.41 6.667 40 6.667 21.59 6.667 6.667 21.59 6.667 40 6.667 58.41 21.59 73.333 40 73.333Z",
    fill: "#828C97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6 56.667h-8.333l-7.466-30h8.333l7.467 30Z",
    fill: "#111213"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m51.666 26.667-7.467 30h8.334l7.466-30M28.333 56.667h8.334l7.433-30h-8.333l-7.434 30Z",
    fill: "#111213"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m28.232 26.667 7.467 30h-8.333l-7.467-30M63.333 35h-10v6.667h10V35Z",
    fill: "#111213"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 35h-10v6.667h10V35Z",
    fill: "#111213"
  })));
};
export default SvgIlGraycoin80Px;